import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-wa-switch',
	templateUrl:'./WaSwitchPage.html',
	styles: [],
	styleUrls:['./WaSwitchPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class WaSwitchPage
{
	mdContent_461 = `\`\`\`java
import com.jwebmp.webawesome.components.waswitch.WaSwitch;
\`\`\``;
	mdContent_462 = `\`\`\`java
new WaSwitch<>()
\`\`\``;
	mdContent_463 = `\`\`\`java
var sw = new WaSwitch<>();
sw.setLabel("Enable notifications");
sw.bind("notifications");
\`\`\``;
}
